import { useState } from "react";
import { RESET_UNREACHABLE } from "../../lib/passwordPolicy";
import { DialogHeader, Popup } from "../../ui/Popup";

export const CHANGE_PASSWORD_TOAST =
  "Check your email for a link to change your password.";

export function ChangePasswordDialog({
  email,
  onClose,
  onSend,
}: {
  email: string;
  onClose: () => void;
  onSend?: (email: string) => Promise<void>;
}) {
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [problem, setProblem] = useState<string | null>(null);

  const send = async () => {
    if (!onSend) return;
    setBusy(true);
    setProblem(null);
    try {
      await onSend(email);
      setSent(true);
    } catch {
      setProblem(RESET_UNREACHABLE);
      setBusy(false);
    }
  };

  return (
    <Popup
      onClose={onClose}
      className="flex max-h-[85vh] w-full max-w-sm flex-col rounded-lg bg-surface text-fg shadow-2xl"
    >
      <DialogHeader title="Change password" onClose={onClose} />
      <div className="space-y-3 p-4">
        {sent ? (
          <p role="status" className="text-xs text-muted">
            {CHANGE_PASSWORD_TOAST}
          </p>
        ) : (
          <>
            <p className="text-xs text-muted">
              We'll email a link to <strong>{email}</strong> to set a new
              password. You'll stay signed in here until you use it.
            </p>
            {problem && <p className="text-xs text-red-400">{problem}</p>}
            <button
              type="button"
              disabled={!onSend || busy}
              className="w-full rounded bg-accent px-3 py-2 text-sm font-medium text-canvas hover:bg-accent-hover disabled:opacity-60"
              onClick={() => void send()}
            >
              Send link
            </button>
          </>
        )}
      </div>
    </Popup>
  );
}
